export class UtilsEngi {
  static hasMinimumCharacters(
    value: string,
    quantity: number
  ): boolean {
    return !!value && !!(value.trim().length >= quantity);
  }
}
